import type { ReactNode } from 'react';
import { FOCUS_RING } from '@/components/console-ui';
import { cn } from 'helpers/cn';
import { ExternalTextLink } from './ChatMessages';

export const TERMS_URL = 'https://www.pertento.ai/terms-and-conditions';
export const PRIVACY_URL = 'https://www.pertento.ai/privacy-policy';

/** "Terms and Conditions and Privacy Policy", both linked, for a notice's own sentence. */
export const TermsAndPrivacyLinks = () => (
  <>
    <ExternalTextLink href={TERMS_URL}>Terms and Conditions</ExternalTextLink> and{' '}
    <ExternalTextLink href={PRIVACY_URL}>Privacy Policy</ExternalTextLink>
  </>
);

type FirstUseNoticeProps = {
  /** What is sent to the AI provider, in the words of the feature it covers. */
  children: ReactNode;
  onAcknowledge: () => void;
};

/**
 * A first-use notice with its one OK. Each feature's server refuses a turn (403) until it is
 * acknowledged, so it stands wherever a first request could be made. The OK carries
 * `data-ai-focus`, for a dialog that moves focus to it.
 */
export const FirstUseNotice = ({ children, onAcknowledge }: FirstUseNoticeProps) => (
  <div>
    <p>{children}</p>
    <button
      type="button"
      data-ai-focus=""
      onClick={onAcknowledge}
      className={cn(
        'mt-3 inline-flex h-8 items-center rounded-lg bg-foreground px-4 text-meta font-medium text-background hover:opacity-90',
        FOCUS_RING,
      )}
    >
      OK
    </button>
  </div>
);
